import { Validator } from 'vee-validate'
import basicinformation from './basicinformation/index.vue';
import detailedinformation from './detailedinformation/index.vue';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';

export default {
 name: 'information',
 components: {
   'first': basicinformation,
   'second': detailedinformation,
 },
 props:['bookingData','status'],
 data() {
   return {
     currentTab: 'First',
     componentKey:1,
     tabs: [
       { key:'First', value:'Basic Information' },
       { key:'Second', value:'Detailed Information' },
     ],
     useremail : '',
     isLoading: false,
     useremail : '',
     clientsystemid : '',
     companyshortname : ''
   }
 },
 created:function() {
 },
 computed: {
   // selects all checkbox's option
   currentTabComponent: function () {
     this.componentKey += 1;
     return this.currentTab.toLowerCase()
   }
 },
 mounted() {
   //console.log("bookingData",this.bookingData);
 },
 methods: {
   resetdata(){
     this.currentTab = 'First';
     this.$refs.moveToNext.resetData();
   },
   childMethod(tabtype, subtabid, clientid, pickuppincode, location, clientbusinessaccountid){
     this.$refs.moveToNext.childMethod(tabtype, subtabid, clientid, pickuppincode, location, clientbusinessaccountid);
   },
   saveAndNext() {
     this.currentTab = 'Second';
   },
   saveBooking(input,type,awbSeries,airCargoAmount) {
      this.$emit("savebooking", input, type,awbSeries,airCargoAmount);
   },
   getSKUList(clientid, clientbusinessaccountid, contractid){
     this.$refs.moveToNext.getSKUList(clientid,clientbusinessaccountid, contractid);
   },
   getClientUOM(clientid, clientbusinessaccountid){
     this.$refs.moveToNext.getClientUOM(clientid, clientbusinessaccountid);
   },
   getInvalidInvoices(errData){
     this.$refs.moveToNext.getInvalidInvoices(errData);
   },
   onTabClick(key){
     if(this.bookingData.bookingmethod == "App" && this.bookingData.pickuplocationname == null && this.bookingData.bookingstatus == "Rapid"){
       document.activeElement.blur();
       this.$alert("Pickup Address fields are empty/not saved in 'Basic Information'. Please fill/save them before filling 'Detailed Information'.", "", "error");
       return false;
     }
     if(this.bookingData.bookingmethod == "App" && this.bookingData.totalshipmentvalues == null && this.bookingData.bookingstatus == "Rapid"){
       document.activeElement.blur();
       this.$alert("Total Shipment Declared Value (INR) field is empty/not saved in 'Basic Information'. Please fill/save them before filling 'Detailed Information'.", "", "error");
       return false;
     }
     if(this.bookingData.bookingmethod == "Upload" && this.bookingData.totalvolumetricweight == null && this.bookingData.bookingstatus == "Rapid"){
       document.activeElement.blur();
       this.$alert("Shipement Box Dimensions are empty/not saved in 'Basic Information'. Please fill/save them before filling 'Detailed Information'.", "", "error");
       return false;
     }
     this.currentTab = key;
   }
 }
}



// WEBPACK FOOTER //
// ./src/modules/cargobooking/views/booking/Information/Information.component.js